import Vue from 'vue'

/**
 * // 自定义时间格式化：支持 yyyy, yy, MM, M, dd, d, hh, h, mm, m, ss, s, SSS, q
 * @param {*number} time 
 * @param {*string} format 
 * @returns 
 */
const formatByPattern = (time, format = 'yyyy-MM-dd hh:mm') => {
    if (time === undefined || time === null || time === '') return '';
    let date;
    if (time instanceof Date) {
        date = time;
    } else if (typeof time === 'number' || /^\d+$/.test(String(time))) {
        const tNum = Number(time);
        date = String(tNum).length === 10 ? new Date(tNum * 1000) : new Date(tNum);
    } else if (typeof time === 'string') {
        // 兼容 "yyyy-mm-dd" 和带时区的 ISO 字符串
        const s = time.includes('T') ? time : time.replace(/-/g, '/');
        date = new Date(s);
    } else {
        date = new Date(time);
    }

    if (isNaN(date.getTime())) return '';

    const map = {
        'yyyy': date.getFullYear(),
        'yy': String(date.getFullYear()).slice(-2),
        'MM': String(date.getMonth() + 1).padStart(2, '0'),
        'M': date.getMonth() + 1,
        'dd': String(date.getDate()).padStart(2, '0'),
        'd': date.getDate(),
        'hh': String(date.getHours()).padStart(2, '0'),
        'h': date.getHours(),
        'mm': String(date.getMinutes()).padStart(2, '0'),
        'm': date.getMinutes(),
        'ss': String(date.getSeconds()).padStart(2, '0'),
        's': date.getSeconds(),
        'SSS': String(date.getMilliseconds()).padStart(3, '0'),
        'q': Math.floor((date.getMonth() + 3) / 3)
    };

    const tokens = Object.keys(map).sort((a, b) => b.length - a.length);
    let result = format
    tokens.forEach(token => {
        result = result.replace(new RegExp(token, 'g'), map[token]);
    });
    return result;
};
/**
 * 参数去空
 * @param {*Object} params
 */
function clearParam(params = {}) {
    let newParams = { ...params }
    for (const key in newParams) {
        if (newParams[key] === '' || newParams[key] === null || newParams[key] === undefined) {
            delete newParams[key]
        }
        if(Array.isArray(newParams[key]) && newParams[key].length === 0){
            delete newParams[key]
        }
    }
    return newParams
}
const initial = {
    $formatTime: formatByPattern,
    $clearParam: clearParam,
}

Object.keys(initial).forEach(key => {
    Vue.prototype[key] = initial[key];
});


// WEBPACK FOOTER //
// ./src/utils/initial.js